// extracted by mini-css-extract-plugin
export var cardLayout = "_a8-1";
export var paginationContainer = "_a8-0";